export function playoutFormat(playout: number | undefined) {
  if (playout) {
    return playout.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1’`);
  }
  return '0';
}
